import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Routerpage from "./Routerpage";
import { ModalContextProvider } from "./context/context";
import { SelectedItemProvider } from "./context/store";
import { LoginProvider } from "./context/contextlogin";
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./queryClient/queryClient";
import { LocationProvider } from "./context/LocationContext";
import { NavbarProvider } from "./context/NavbarContext";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <ModalContextProvider>
          <SelectedItemProvider>
            <LoginProvider>
              <LocationProvider>
                <NavbarProvider>
                <Routerpage />
                </NavbarProvider>
              </LocationProvider>
            </LoginProvider>
          </SelectedItemProvider>
        </ModalContextProvider>
      </HelmetProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.StrictMode>
);


reportWebVitals();
